import { render, staticRenderFns } from "./historico.vue?vue&type=template&id=759616be"
import script from "./historico.vue?vue&type=script&lang=js"
export * from "./historico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports